<template>
    <section class="section is-small is-white has-text-centered is-long">
        <div class="container">
            <div class="columns is-centered is-desktop">
                <div class="column is-one-quarter-desktop is-12-tablet" v-for="feature in features" :key="feature.id">
                    <div class="card is-br-25">
                        <header class="card-header">
                            <div class="column">
                                <div class="title">
                                    <img :src="require(`@/assets/img/svg/${feature.image}`)" :alt="feature.title" class="is-50x50">
                                </div>
                                <div class="subtitle">
                                    {{feature.title}}
                                </div>
                            </div>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <p>
                                    {{feature.desc}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['features']
}
</script>

